import { MOCK_ICON } from './_common';

const popupImageLink = (text: string, url = '#') => ({
  image: null,
  link: {
    text,
    url,
    openInNewTab: false,
    variant: 'text' as const,
    color: 'primary' as const,
  },
  popup: null,
});

const iconLink = (url = '#') => ({
  image: MOCK_ICON,
  link: {
    text: null,
    url,
    openInNewTab: false,
    variant: null,
    color: null,
  },
  popup: null,
});

const bentoFooterMock = {
  block: {
    logo: {
      ...MOCK_ICON,
      altText: 'Decodo',
    },
    contacts: [
      {
        title: 'Get in touch',
        links: [iconLink('#'), iconLink('mailto:sales@decodo.com')],
      },
      {
        title: 'Follow us',
        links: [iconLink('#'), iconLink('#'), iconLink('#')],
      },
    ],
    categories: [
      {
        title: 'Company',
        links: [
          popupImageLink('About us', '/about-us'),
          popupImageLink('Careers', '/careers'),
          popupImageLink('Community', '/community'),
        ],
      },
      {
        title: 'Products',
        links: [
          popupImageLink('Proxy servers', '/proxies'),
          popupImageLink('Residential proxies', '/residential-proxies'),
          popupImageLink('Web scraping API', '/web-scraping-api'),
        ],
      },
      {
        title: 'General',
        links: [
          popupImageLink('FAQ', '/faq'),
          popupImageLink('Billing', '/billing'),
          popupImageLink('Documentation', '/documentation'),
        ],
      },
    ],
  },
};

export default bentoFooterMock;
